import styled from 'styled-components'
import { COLOR, FONT_SIZE } from '../../../../../../../themes'

export const OrderModalTabStyle = styled.form`
  display: flex;
  justify-content: center;
  gap: 40px;
  font-size: ${FONT_SIZE.XXS};
  font-family: NunitoSansBold;
  position: relative;
  background-color: ${COLOR.WHITE};
  z-index: 3;

  label {
    cursor: pointer;
    padding: 8px 16px;
  }

  input {
    display: none;
  }
`
